import { render, staticRenderFns } from "./ComplianceControllers.vue?vue&type=template&id=6ec06527&"
import script from "./ComplianceControllers.vue?vue&type=script&lang=js&"
export * from "./ComplianceControllers.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceControllers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports